import React from "react";

const ModalForm = ({
  score,
  onChangeScore,
  review,
  onChangeReview,
  onClose,
  onSubmit,
}) => {
  return (
    <div className="share-middle-pop-ui open" style={{ zIndex: 30000 }}>
      <span className="dim"></span>
      <div className="dp-table pos-a">
        <div className="dp-cell">
          <div className="star-rating-box">
            <div className="star-rating-tit-area">
              <h2 className="star-rating-tit">
                홈런 AI수학진단검사는 어떠셨나요?
              </h2>
            </div>
            <div className="star-rating-main-area">
              <div className="rating-mark-box">
                <p className="rating-mark-tit">별표를 눌러 평가해주세요.</p>
                <ul className="rating-mark">
                  <li className={"mark-item" + (score >= 1 ? " on" : "")}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => onChangeScore(1)}
                    >
                      <i className="icon i-btn-star">별 아이콘</i>
                    </button>
                  </li>
                  <li className={"mark-item" + (score >= 2 ? " on" : "")}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => onChangeScore(2)}
                    >
                      <i className="icon i-btn-star">별 아이콘</i>
                    </button>
                  </li>
                  <li className={"mark-item" + (score >= 3 ? " on" : "")}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => onChangeScore(3)}
                    >
                      <i className="icon i-btn-star">별 아이콘</i>
                    </button>
                  </li>
                  <li className={"mark-item" + (score >= 4 ? " on" : "")}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => onChangeScore(4)}
                    >
                      <i className="icon i-btn-star">별 아이콘</i>
                    </button>
                  </li>
                  <li className={"mark-item" + (score >= 5 ? " on" : "")}>
                    <button
                      type="button"
                      className="btn"
                      onClick={() => onChangeScore(5)}
                    >
                      <i className="icon i-btn-star">별 아이콘</i>
                    </button>
                  </li>
                </ul>
              </div>

              <div className="rating-write-box">
                <p className="rating-write-tit">
                  서비스를 이용하시면서 느낀 점을 간략하게 적어주세요.
                </p>

                <div className="rating-write-txt">
                  <textarea
                    id=""
                    className="rating-write-txtarea"
                    name=""
                    placeholder="10자 이상 입력해주세요."
                    value={review}
                    onChange={onChangeReview}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="star-rating-btn-area">
              <ul className="star-rating-btn">
                <li className="star-rating-btn-item">
                  <button className="btn btn-popup-line" onClick={onClose}>
                    <span className="txt">닫기</span>
                  </button>
                </li>
                <li className="star-rating-btn-item">
                  <button className="btn btn-popup-fill" onClick={onSubmit}>
                    <span className="txt">작성 완료</span>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
